import {
  Box,
  Typography,
  Card,
  CardMedia,
  Stack,
  CardContent,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import { doc, getDoc, setDoc } from "firebase/firestore";
import Cookies from "js-cookie";
import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Update } from "../../../App";
import { db } from "../../../components/firebase";
import AddExercise from "../AddExercise";
import DoneIcon from "@mui/icons-material/Done";
import { motion } from "framer-motion";
import CreateIcon from "@mui/icons-material/Create";
const CustomizeExercise = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [display, setDisplay] = useState("none");
  const { setDisplayAppBar, setCustomizeGymExercises, customizeGymExercises } =
    useContext(Update);
  const [option, setOption] = useState(0);
  const [data, setData] = useState(0);
  const [recentlyAddedList, setRecentlyAddedList] = useState([]);
  useEffect(() => {
    if (location.pathname) {
      setDisplayAppBar("none");
    }
    async function getData() {
      try {
        let d = await getDoc(
          doc(db, Cookies.get("_hash"), `${location.pathname.split(":")[1]}`)
        );
        setRecentlyAddedList(d.data().recentlyAddedList);
      } catch (err) {
        console.log(err);
      }
    }
    getData();
    localStorage.setItem("document",`${location.pathname.split(":")[1]}`);
  }, []);
  useEffect(()=>{
    console.log(recentlyAddedList)
  },[recentlyAddedList])
  useEffect(() => {
    if (recentlyAddedList.length > 0) {
      setOption(1);
    }
    console.log(recentlyAddedList);
  }, [recentlyAddedList]);

  function getColor(value) {
    const r = 255 - Math.floor(Math.random() * value);
    const g = 255 - Math.floor(Math.random() * value);
    const b = 255 - Math.floor(Math.random() * value);
    return `rgb(${r},${b},${g})`;
  }

  return (
    <Box>
      <AddExercise
        recentlyAddedList={recentlyAddedList}
        setRecentlyAddedList={setRecentlyAddedList}
        display={display}
        setDisplay={setDisplay}
      />
      <Box
        sx={{
          height: "300px",
          boxShadow: "0px 0px 201px 2px white",
          background: `linear-gradient(to right bottom,${getColor(
            70
          )},${getColor(150)})`,
        }}
        onClick={() => {
          setDisplay("none");
        }}
      ></Box>
      {option === 0 ? (
        <Box
          onClick={() => {
            setDisplay("none");
          }}
        >
          <CreateIcon
            sx={{
              color: "grey",
              mt: { sm: "400px", lg: "390px" },
              ml: { sm: "53%", lg: "40%" },
            }}
          />
          <Typography sx={{ color: "grey", ml: { sm: "45%", lg: "36.3%" } }}>
            No customized workout
          </Typography>{" "}
        </Box>
      ) : (
        <Stack
          onClick={() => {
            setDisplay("none");
          }}
          id="slider"
          sx={{
            overflowY: "scroll",
            mb: "1%",
            ml: "2%",
          }}
        >
          {recentlyAddedList.map((item, index) => (
            <Card
              component={motion.div}
              initial={{ x: -10, duration: "1sec" }}
              animate={{ x: 10 }}
              whileHover={{ scale: 1.05 }}
              sx={{
                boxShadow: "0px 0px 2px 1px grey",
                mt: "2%",
                width: { sm: "89vw" },
                height: {
                  xs: "60vw",
                  sm: "39vw",
                  md: "28vw",
                  lg: "20vw",
                  xl: "13vw",
                },
              }}
            >
              <Stack direction="row">
                <CardMedia
                  component="img"
                  src={item.gifUrl}
                  sx={{ width: "270px" }}
                />
                <CardContent>
                  <CardContent
                    sx={{ fontWeight: "900", fontFamily: "monospace" }}
                  >
                    {item.name}
                  </CardContent>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      label="Reps"
                      type="number"
                      defaultValue={
                        recentlyAddedList[index].reps === undefined
                          ? 0
                          : item.reps
                      }
                      onChange={(e) => {
                        setData(e.target.value);
                      }}
                      sx={{ width: "140px" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <DoneIcon
                              color="success"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                const list = recentlyAddedList;
                                list[index].reps = data;
                                list[index]["stopwatch"] = false;
                                setRecentlyAddedList(list);
                                async function setReps() {
                                  await setDoc(
                                    doc(
                                      db,
                                      Cookies.get("_hash"),
                                      `${location.pathname.split(":")[1]}`
                                    ),
                                    { recentlyAddedList: recentlyAddedList }
                                  );
                                }
                                setReps();
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Typography sx={{ fontWeight: "bold", pt: "5%" }}>
                      or
                    </Typography>
                    <TextField
                      label="Stopwatch"
                      type="number"
                      defaultValue={
                        recentlyAddedList[index].reps === undefined
                          ? 0
                          : item.reps
                      }
                      onChange={(e) => {
                        setData(e.target.value);
                      }}
                      sx={{ width: "140px" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <DoneIcon
                              color="success"
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                const list = recentlyAddedList;
                                list[index].reps = data;
                                list[index]["stopwatch"] = true;
                                setRecentlyAddedList(list);
                                async function setReps() {
                                  await setDoc(
                                    doc(
                                      db,
                                      Cookies.get("_hash"),
                                      `${location.pathname.split(":")[1]}`
                                    ),
                                    { recentlyAddedList: recentlyAddedList }
                                  );
                                }
                                setReps();
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                  <Stack direction="row">
                    <CardContent
                      sx={{
                        fontWeight: "700",
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      }}
                    >
                      BodyPart
                    </CardContent>
                    <CardContent
                      sx={{
                        fontWeight: "700",
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      }}
                    >
                      Equipment
                    </CardContent>
                  </Stack>
                  <Stack direction="row">
                    <CardContent
                      sx={{
                        color: "red",
                        fontWeight: "700",
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      }}
                    >
                      {item.bodyPart}
                    </CardContent>
                    <CardContent
                      sx={{
                        color: "green",
                        fontWeight: "700",
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      }}
                    >
                      {item.equipment}
                    </CardContent>
                  </Stack>
                </CardContent>
              </Stack>
            </Card>
          ))}
          <CardContent sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                localStorage.setItem('mode','customized')
                async function getExercise() {
                  const a = await getDoc(
                    doc(db,Cookies.get("_hash"),`${localStorage.getItem("document")}`))
                    .then((res) => {
                      {console.log(res.data());
                        return res.data();};
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                  setCustomizeGymExercises(a);
                navigate("/gym/workout");
                }
                getExercise();
              }}
            >
              Start
            </Button>
          </CardContent>
        </Stack>
      )}
    </Box>
  );
};

export default CustomizeExercise;
